"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _useAddressSearchError = require("../../hooks/error/useAddressSearchError");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StyledGrid = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.Grid);
var AddressSearchError = function AddressSearchError() {
  var _useAddressSearchErro = (0, _useAddressSearchError.useAddressSearchError)(),
    title = _useAddressSearchErro.title,
    errorMessage = _useAddressSearchErro.errorMessage,
    btnText = _useAddressSearchErro.btnText,
    gotoQuestionById = _useAddressSearchErro.gotoQuestionById;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledGrid, {
    className: "error-page"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: '146px',
      paddingBottom: '35px'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "location",
    group: "hifiLight",
    size: 3
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    weight: 3,
    size: 2
  }, title))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 9,
    colMd: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    justify: "center",
    weight: 1
  }, errorMessage)))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '220px'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: "center",
    layout: {
      sm: [12],
      md: [6]
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    width: "full",
    text: btnText,
    onClick: function onClick() {
      gotoQuestionById();
    }
  }))))));
};
var _default = AddressSearchError;
exports.default = _default;